/* eslint-disable camelcase */
import CustomMarkdown from '@/molecules/CustomMarkdown';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import { usePutEvent } from 'hooks/queries/events';
import { useTranslation } from 'react-i18next';
import { useCmsData } from 'utils/cms';
import dtoSpecificFields from 'utils/cms/dtoSpecificFields';
import Image from 'utils/Image';

type Props = {
  closeModal: () => void;
  canCloseEvent: boolean;
  eventId: string;
};

const ModalCloseEvent = ({ closeModal, canCloseEvent, eventId }: Props) => {
  const { t } = useTranslation();

  const {
    acf: { widgets },
  } = useCmsData();
  const { putEvent } = usePutEvent();

  const { shop_edit_event_cant_close_event, shop_edit_event_can_close_event } = dtoSpecificFields(widgets);

  const handleCloseEvent = () => {
    if (canCloseEvent) {
      putEvent.mutate({ event: { status: 'FINISHED' }, id: eventId });
    }
  };

  return (
    <ModalClassicLayout
      closeModal={closeModal}
      onSubmit={handleCloseEvent}
      title={t('event.admin.modal.closeEventTitle')}
    >
      <CustomMarkdown className="text-neutral-800">
        {canCloseEvent ? shop_edit_event_can_close_event : shop_edit_event_cant_close_event}
      </CustomMarkdown>
      <Image
        alt=""
        className="m-auto my-8"
        height="280"
        loading="lazy"
        src={canCloseEvent ? '/faction_blasons.png' : '/emotes/frog-thinking.png'}
        width="280"
      />
    </ModalClassicLayout>
  );
};

export default ModalCloseEvent;
